module.exports = __webpack_public_path__ + "img/wechatNumber.c513d56b.png";